module.exports = __webpack_public_path__ + "static/media/background-visit-levi.c3c66c6c.jpg";